<div class="overflow-hidden" style="height: 100%; position: relative">
  <ng-container *ngIf="!isFailure; else error">
    <ng-content></ng-content>
  </ng-container>

  <ng-template #error>
    <man-table-error [request]="request"></man-table-error>
  </ng-template>
</div>
